<template>
	<div style="width:660px; height:500px;" v-on:keyup.esc="close()">
		<table class="view_tbl" border="0">
			<colgroup>
				<col style="width:120px;" />
				<col style="width:90px;" />
				<col style="width:100px;" />
				<col style="" />
			</colgroup>
			<tbody>
				<tr>
					<th>Payment Date</th>
					<td><CustomDatePicker v-model="payment_date" /></td>
					<th>Pay Amount</th>
					<td><currency-input type="text" v-model.trim="totalPayAmount" :disabled="true" :precision="2" style="font-weight:bold;width:90px;" class="al_right" readonly /></td>
				</tr>
			</tbody>
		</table>

		<div class="view_inner">
			<table class="list_tbl2" border="0">
				<thead>
					<tr>
						<th width="21%">Payment Method</th>
						<th width="18%">Post Check Date</th>
						<th>Check No / Info.</th>
						<th width="15%">Amount</th>
						<th width="10%">
							<template v-if="!['minkhair'].includes(company_id)">
								Add/Del
							</template>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(method, index) in payment_methods" v-bind:key="index">
						<td class="al_left">
							<select v-model="method.payment_type" class="tbl_select">
								<option v-for="paymentType in paymentTypes" v-bind:value="{ code: paymentType.code, name: paymentType.name }" v-bind:key="paymentType.code">{{ paymentType.name }}</option>
							</select>
						</td>
						<td><CustomDatePicker v-if="postCheck(method)" v-model="method.post_check_date" /></td>
						<td><input type="text" class="r_int long_type al_left" v-model="method.check_no" placeholder="Check No or Pay Info." autocomplete="off" @focus="$event.target.select()" /></td>
						<td><currency-input type="text" v-model.trim="method.amount" :precision="2" class="r_int long_type al_right" @focus="$event.target.select()" /></td>
						<td>
							<template v-if="!['minkhair'].includes(company_id)">
								<a v-if="index == payment_methods.length - 1" href="javascript:;" type="button" class="gray_bt" @click="addMethod(method)">Add</a>
								<a v-else href="javascript:;" type="button" class="gray_bt" @click="delMethod(index)">Del</a>
							</template>
						</td>
					</tr>
					<tr>
						<td class="al_right" colspan="3">Total</td>
						<td><currency-input type="text" v-model.trim="amountTotal" :precision="2" class="r_int long_type al_right" readonly /></td>
						<td></td>
					</tr>
				</tbody>
			</table>

			<input type="text" class="r_int long_type al_left" v-model="remark" placeholder="Remark" autocomplete="off" @focus="$event.target.select()" />

			<br />

			<div class="view_bottom_bt" style="padding-top:20px;">
				<a href="javascript:;" type="button" class="search_bt" @click="save()">Save</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
import { apiIndex, apiProcessPayment } from '@/api/payment/index.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today, isDate } from '@/utils/date.js';

export default {
	data: function() {
		return {
			payment_date: today(),
			remark: null,
			payment_methods: [],

			paymentTypes: [],

			first_vendor_code: null,

			//partner: {},
		};
	},
	computed: {
		amountTotal: {
			get: function() {
				var sum = 0;
				this.payment_methods.forEach(function(method) {
					if (method.amount) sum += method.amount;
				});

				sum = parseFloat(sum.toFixed(2));
				return sum;
			},
			set: function() {},
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
	},
	props: {
		toPaymentPOs: Array,
		totalPayAmount: Number,
	},
	components: {
		CustomDatePicker,
	},
	methods: {
		delMethod(index) {
			this.payment_methods.splice(index, 1);
		},
		addMethod(method) {
			this.payment_methods.push({ payment_type: { code: method.payment_type.code, name: method.payment_type.name }, amount: this.totalPayAmount - this.amountTotal });
		},
		postCheck(method) {
			if (method.payment_type.name.toUpperCase().indexOf('POST') >= 0) {
				method.post_check_yn = 'Y';
				return true;
			} else {
				method.post_check_yn = 'N';
				return false;
			}
		},
		close() {
			this.$emit('close');
		},
		async save() {
			if (!this.payment_date || !isDate(this.payment_date)) {
				this.$toast.error('Invalid payment date');
				return;
			}
			if (this.amountTotal != this.totalPayAmount) {
				//console.log(this.amountTotal, this.totalReceiptAmount);
				this.$toast.error('Amounts do not match.');
				return;
			}
			if (this.payment_methods.filter(method => method.post_check_yn == 'Y').length > 1) {
				this.$toast.error('Only one post check is allowed for one payment.');
				return;
			}

			var con = true;
			var vm = this;
			var valid_payment_date = this.payment_date;

			this.payment_methods.forEach(function(method) {
				if (method.post_check_yn == 'Y' && (!method.post_check_date || !isDate(method.post_check_date))) {
					vm.$toast.error('Invalid post check date');
					con = false;
				} else if (method.post_check_yn == 'Y') valid_payment_date = method.post_check_date;

				if (method.payment_type.name.toUpperCase().indexOf('CHECK') >= 0 && !method.check_no) {
					vm.$toast.error('Some check no is empty.');
					con = false;
				}
			});
			if (!con) return;

			if (this.payment_methods.filter(method => method.post_check_yn == 'Y').length > 0 && this.payment_methods.length > 1) {
				this.$toast.error('Post check is not allowed with other payment methods.');
				return;
			}

			//console.log(this.payment_methods);
			var param = {
				total_amount: this.totalPayAmount,
				payment_date: this.payment_date,
				valid_payment_date: valid_payment_date,
				payment_methods: this.payment_methods,
				pos: this.toPaymentPOs,
				remark: this.remark,
			};
			// console.log(param);

			// var dummy = 1;
			// if (dummy) return;

			const { data } = await apiProcessPayment(param);

			if (data.result) {
				this.$toast.success('Payment processed successfully');
				this.$emit('payment-call-back', true);
				this.close();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async init() {
			const { data } = await apiIndex();

			this.paymentTypes = data.paymentTypeList;

			if (this.paymentTypes.length > 0) {
				this.payment_methods.push({ payment_type: { code: this.paymentTypes[0].code, name: this.paymentTypes[0].name }, amount: this.totalPayAmount });
				//console.log(this.payment_methods);
			}
		},
	},
	created() {
		// const first_invoice_with_bill_to = this.toReceiveInvoices.filter(i => i.bill_to_code)[0];
		// if (first_invoice_with_bill_to) this.first_bill_to_code = first_invoice_with_bill_to.bill_to_code;

		this.payment_methods = [];

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
